import { render, staticRenderFns } from "./indexMainRight.vue?vue&type=template&id=2ec36e01&scoped=true&"
import script from "./indexMainRight.vue?vue&type=script&lang=js&"
export * from "./indexMainRight.vue?vue&type=script&lang=js&"
import style0 from "./indexMainRight.vue?vue&type=style&index=0&id=2ec36e01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec36e01",
  null
  
)

export default component.exports